import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import IncomingInvoiceForm from "./incomingInvoice/incomingInvoiceForm";
import IncomingPaymentForm from "./incomingPayment/incomingPaymentForm";
import OutgoingPaymentForm from "./outgoingPayment/outgoingPaymentForm";
import InvoiceForm from "./invoice/invoiceForm/invoiceForm";
import InvoiceDetail from "./invoice/invoiceDetail/invoiceDetail";
import IncomingInvoiceDetail from "./incomingInvoice/incomingInvoiceDetail/incomingInvoiceDetail";
import IncomingPaymentDetail from "./incomingPayment/incomingPaymentDetail/incomingPaymentDetail";
import OutgoingPaymentDetail from "./outgoingPayment/outgoingPaymentDetail/outgoingPaymentDetail";
import ExchangeRate from "./exchangeRate/exchangeRate";
import FiscalPeriodList from "./openClosePeriod/fiscalPeriodList";
import RecInvoiceDetail from "./invoice/recInvoiceDetail/recInvoiceDetail";
import RecIncomingInvoiceDetail from "./incomingInvoice/recIncomingInvoiceDetail/recIncomingInvoiceDetail";
import Invoice from "./invoice";
import Payment from "./payment";
import FinanceReport from "./financeReport/financeReport";
import JournalEntriesForm from "./journalEntries/journalEntriesForm/journalEntriesForm";
import AssetList from "./asset/assetList";
import AssetDetail from "./asset/assetDetail/assetDetail";
import JournalEntriesList from "./journalEntries/JournalEntriesList";

export default function FinancePage() {
  return (
    <Switch>
      <Redirect
        exact={true}
        from="/finance"
        to="/finance/invoices/:invoiceStream"
      />
      <Route path="/finance/invoices/:invoiceStream" component={Invoice} />
      <Route path="/finance/create-invoice" component={InvoiceForm} />
      <Route path="/finance/edit-invoice/:invoiceID" component={InvoiceForm} />
      <Route
        path="/finance/invoice-detail/:invoiceID"
        component={InvoiceDetail}
      />
      <Route
        path="/finance/rec-invoice-detail/:invoiceID"
        component={RecInvoiceDetail}
      />
      <Route
        path="/finance/create-incoming-invoice"
        component={IncomingInvoiceForm}
      />
      <Route
        path="/finance/edit-incoming-invoice/:invoiceID"
        component={IncomingInvoiceForm}
      />
      <Route
        path="/finance/incoming-invoice-detail/:invoiceID"
        component={IncomingInvoiceDetail}
      />
      <Route
        path="/finance/rec-incoming-invoice-detail/:invoiceID"
        component={RecIncomingInvoiceDetail}
      />
      <Route path="/finance/payments/:paymentStream" component={Payment} />
      <Route
        path="/finance/create-incoming-payment"
        component={IncomingPaymentForm}
      />
      <Route
        path="/finance/edit-incoming-payment/:paymentID"
        component={IncomingPaymentForm}
      />
      <Route
        path="/finance/incoming-payment-detail/:paymentID"
        component={IncomingPaymentDetail}
      />
      <Route
        path="/finance/create-outgoing-payment"
        component={OutgoingPaymentForm}
      />
      <Route
        path="/finance/edit-outgoing-payment/:paymentID"
        component={OutgoingPaymentForm}
      />
      <Route
        path="/finance/outgoing-payment-detail/:paymentID"
        component={OutgoingPaymentDetail}
      />
      <Route path="/finance/assets" component={AssetList} />
      <Route path="/finance/asset-detail/:assetID" component={AssetDetail} />
      <Route path="/finance/exchange-rate" component={ExchangeRate} />
      <Route
        path="/finance/journal-entry-form"
        component={JournalEntriesForm}
      />
      <Route path="/finance/open-close-period" component={FiscalPeriodList} />
      <Route path="/finance/finance-reports" component={FinanceReport} />
      <Route path="/finance/journal-entries" component={JournalEntriesList} />
    </Switch>
  );
}
